var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"t-link-back",attrs:{"to":{name: _vm.linkName}}},[_c('svg',{staticClass:"t-link-back__svg",attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3 12H21M7 16L3 12L7 16ZM3 12L7 8L3 12Z","stroke":"#00b0bd","stroke-width":"1.7","stroke-linecap":"round","stroke-linejoin":"round"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.btn))])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/lk/link-back/link-back.vue?vue&type=template&id=55448a36&
// module id = 1090
// module chunks = 0